import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuthContext } from '../hooks/useAuthContext'
import { useStateContext } from '../../../context/StateContext'
import { AuthContext } from '../../../context/AuthContext'
import T from '../../../components/Translation'
import BlueButton from '../../../components/BlueButton'


const AuthNav = ({resetContextFn=() => {}, AuthContext}) => {

    const { user } = useAuthContext(AuthContext)
    const { surveyResponseDoc, setShowSidebar } = useStateContext()
    const surveyUrl = `${window.location.origin}/survey?_id=${surveyResponseDoc?.surveyId}`
  

  return (
    <div>
        <nav style={{ padding: '8px 5px' }}>
          {surveyResponseDoc && (
              <BlueButton 
              fn={() => window.open(surveyUrl, '_blank')}
              text={<T obj={{"en": "Survey In Progress", "it": "Questionario In Corso"}}/>}
              color="green"
            />
          )}
{/*           {user && (
            <div style={{ 
              display: 'flex', 
              alignItems: 'left', 
              gap: '16px'
            }}>
              <button onClick={logOutFn}>Log out</button>
            </div>
          )} */}
          {!user && (
            <div style={{ 
              display: 'flex', 
              alignItems: 'left', 
              gap: '5px' 
            }}>
              <Link onClick={() => setShowSidebar(false)} to="/login" style={{ textDecoration: 'none', color: 'inherit' }}><T str={"logIn"}/></Link>
              <Link onClick={() => setShowSidebar(false)} to="/signup" style={{ textDecoration: 'none', color: 'inherit' }}><T str={"signUp"}/></Link>
            </div>
          )}
           <LanguageToggle/>
        </nav>
    </div>
  )
}

export default AuthNav

export const LanguageToggle = () => {
  const { language, setLanguage } = useStateContext()
  const {user} = useAuthContext(AuthContext) 
  const languages = ["it", "en"]
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => setIsOpen(!isOpen)

  const handleLanguageChange = (lang) => {
    setLanguage(lang)
    setIsOpen(false)
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div 
        onClick={toggleDropdown}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '4px 8px',
          marginLeft: '8px',
          //border: '1px solid #ddd',
          borderRadius: '4px'
        }}
      >
        <img 
          src={`/flags/${language}.svg`} 
          alt={`${language} flag`}
          style={{ width: '24px', height: '16px', objectFit: 'cover' }}
        />
        <span style={{ fontSize: '14px' }}>{language.toUpperCase()}</span>
      </div>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: '0',
          backgroundColor: 'white',
          border: '1px solid #ddd',
          borderRadius: '4px',
          marginTop: '10px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          zIndex: 1000,
          paddingBottom:"15px"
        }}>
          {languages?.map(lang => (
            <div
              key={lang}
              onClick={() => handleLanguageChange(lang)}
              style={{
                display: 'flex',
                marginTop:"15px",
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                cursor: 'pointer',
                hover: {
                  backgroundColor: '#f5f5f5'
                }
              }}
            >
              <img 
                src={`/flags/${lang}.svg`} 
                alt={`${lang} flag`}
                style={{ width: '24px', height: '16px', objectFit: 'cover' }}
              />
              <span style={{ fontSize: '14px' }}>{lang.toUpperCase()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
